class ProductCardCarousel extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    const track = this.querySelector('.product-card-carousel__track');
    const dots = Array.from(this.querySelectorAll('[data-slide]'));
    const slides = Array.from(track.children);
    const update = () => {
      const trackLeft = track.getBoundingClientRect().left;
      let active = 0;
      let distance = Infinity;
      slides.forEach((slide, index) => {
        const current = Math.abs(slide.getBoundingClientRect().left - trackLeft);
        if (current < distance) {
          distance = current;
          active = index;
        }
      });
      dots.forEach((dot, index) => dot.setAttribute('aria-pressed', String(index === active)));
    };
    track.addEventListener('scroll', () => {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        update();
      });
    }, { ...options, passive: true });
    this.addEventListener('click', (event) => {
      const dot = event.target.closest('[data-slide]');
      if (!dot) return;
      const slide = slides[Number(dot.dataset.slide)];
      const delta = slide.getBoundingClientRect().left - track.getBoundingClientRect().left;
      track.scrollBy({ left: delta, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }, options);
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.controller = null;
    cancelAnimationFrame(this.frame);
    this.frame = null;
  }
}

customElements.define('product-card-carousel', ProductCardCarousel);
